import { z } from 'zod';
import _isNaN from 'lodash/isNaN';

export const FORM_SCHEMA = z.object({
  is_active: z.boolean(),
  name: z.string().min(1, 'Required'),
  service_days: z
    .string()
    .min(1, 'Required')
    .refine(value => !_isNaN(Number(value)), { message: 'Must be a number' }),
  count_days_from_delivered_at: z.boolean(),
  product_variants: z.array(z.string()).optional(),
  product_types: z.array(z.string()).optional(),
  products: z
    .array(
      z.object({
        ObjectId: z.string(),
        productVariants: z.array(
          z.object({
            objectID: z.string()
          })
        )
      })
    )
    .optional()
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  is_active: true,
  name: '',
  service_days: '7',
  products: [],
  product_variants: [],
  product_types: [],
  count_days_from_delivered_at: true
};
